import { useState, useEffect } from 'react'

const CountdownDays = ({ date }: { date: string }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0 })

  useEffect(() => {
    const targetDate = new Date(date).getTime()

    const updateCountdown = () => {
      const now = new Date().getTime()
      const difference = targetDate - now

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24))
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))

        setTimeLeft({ days, hours, minutes })
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0 })
      }
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000 * 60)

    return () => clearInterval(interval)
  }, [date])

  return (
    <>
      {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m
    </>
  )
}

export default CountdownDays
